import React from 'react';
import { MyTransactionsTable } from '../components/MyTransactions/MyTransactionsTable';

export function MyTransactions() {
  return (
    <div>
      <MyTransactionsTable />
    </div>
  );
}
